module.exports = __webpack_public_path__ + "img/github.a112a001.svg";